<template>
  <div style="height: 60px" id="curTime">&nbsp;</div>
  <div v-if="!processMSG && !myUser">
    <form>
      <div
        style="
          margin-left: auto;
          margin-right: auto;
          width: 100%;
          text-align: center;
        "
      >
        <table class="tab_view" style="width: 250px; margin: 0 auto">
          <tr>
            <td><label>Benutzer:</label></td>
            <td><input type="text" id="uname" v-model="usern" /></td>
          </tr>
          <tr>
            <td><label>Passwort:</label></td>
            <td><input type="password" id="upw" v-model="userp" /></td>
          </tr>
          <tr>
            <td
              style="
                text-align: center;
                width: 100%;
                padding-top: 15px;
                padding-bottom: 15px;
              "
              colspan="2"
            >
              <span
                class="act_button"
                @click="do2FAlogon"
                v-if="!logonattempts || logonattempts < 3"
                >Anmelden</span
              >
            </td>
          </tr>
          <tr v-if="logonattempts && logonattempts > 2">
            <td
              style="
                text-align: center;
                width: 100%;
                padding-top: 15px;
                padding-bottom: 15px;
              "
              colspan="2"
            >
              Please solve this:
              <span>
                {{ cam0 }} + {{ cam1 }} = <input id="MyCamp" />
                <button v-on:click="solveCam">Check</button>
              </span>
            </td>
          </tr>
          <tr>  
            <td colspan="2" style="text-align: center;"><span><a href="/carforce/uss">Passwort vergessen</a></span></td>
          </tr>
        </table>
      </div>
    </form>
    <div class="info_red">{{ statusMSG }}</div>
  </div>
  <div v-if="email_send == 1 ? true : false">
    <p>
      Einmal-Token:&nbsp;<input v-model="tokenInput" />&nbsp;<span
        class="act_button"
        v-on:click="checkToken(tokenInput)"
        >Senden</span
      >
    </p>
  </div>
  <div>
    <span class="info_yellow" v-if="processMSG"
      >{{ processMSG }}<br /><br
    /></span>
  </div>
  <div v-if="pwsChange ? true : false">
    <table class="tab_view" style="margin-left: 40%; width: 300px">
      <tr>
        <td style="text-align: center; width: 100%" colspan="2">
          <span style="color: red; font-size: larger; font-weight: bold"
            >Passwortänderung erforderlich: {{ myUser.SesUserObjectName }}</span
          >
        </td>
      </tr>
      <tr>
        <td><label>Passwort-alt:</label></td>
        <td><input type="password" id="uname" v-model="curPW" /></td>
      </tr>
      <tr>
        <td><label>Passwort-neu:</label></td>
        <td>
          <input type="password" id="upw" v-model="newPW1" /><br />
          <span
            v-bind:style="
              chkPW
                ? 'font-size:10px;color:GreenYellow;'
                : 'font-size:10px;color:yellow;'
            "
            >Min. 8 Zeichen (groß/klein), Zahl(en), Sonderzeichen</span
          >
        </td>
      </tr>
      <tr>
        <td><label>Passwort-bestätigen:</label></td>
        <td><input type="password" v-model="newPW2" /></td>
      </tr>
      <tr>
        <td style="text-align: center; width: 100%" colspan="2">
          <span class="act_button" @click="doPWS"
            >Neues Passwort speichern</span
          >
          <span class="cancel_button" @click="doPWSReset">Abbruch</span>
        </td>
      </tr>
    </table>
  </div>
  <div style="width: 100%; font-size: larger" v-if="pwsChange ? false : true">
    <router-link v-if="$root.isDispo" to="/mybookings"
      ><img
        alt="Bookings"
        title="Buchungen | Bookings"
        src="../assets/bookings.svg"
        style="width: 60px; height: 60px"
      /><br />Buchungen</router-link
    >
    <div v-if="$root.isDispo" style="width: 20px">&nbsp;</div>
    <router-link v-if="$root.isDispo" to="/myoverview"
      ><img
        title="Kalender | Calendar view"
        src="../assets/day.svg"
        style="width: 60px; height: 60px"
      /><br />Kalender</router-link
    >
    <div v-if="$root.isDispoAdmin" style="width: 20px">&nbsp;</div>
    <router-link v-if="$root.isDispoAdmin" to="/myusers"
      ><img
        title="Benutzer | Users"
        src="../assets/users.svg"
        style="width: 60px; height: 60px"
      /><br />Benutzerverwaltung</router-link
    >
    <div v-if="$root.isAdmin" style="width: 20px">&nbsp;</div>
    <router-link v-if="$root.isAdmin" to="/myadresses"
      ><img
        title="Adressen | Adresses"
        src="../assets/address.svg"
        style="width: 60px; height: 60px"
      /><br />Adressenverwaltung</router-link
    >
    <div v-if="$root.isAdmin" style="width: 20px">&nbsp;</div>
    <router-link v-if="$root.isAdmin" to="/mycompanies"
      ><img
        title="Firmen | Companies"
        src="../assets/company.svg"
        style="width: 60px; height: 60px"
      /><br />Firmenverwaltung</router-link
    >
    <div v-if="$root.isAdmin" style="width: 20px">&nbsp;</div>
    <router-link v-if="$root.isAdmin" to="/mycargroups"
      ><img
        title="Fahrzeuggruppen | Car groups"
        src="../assets/cargroups.svg"
        style="width: 60px; height: 60px"
      /><br />Fahrzeuggruppen</router-link
    >
  </div>
  <div v-if="isLoggedOn" style="width: 20px; line-height: 50px">&nbsp;</div>
  <div v-if="isLoggedOn" style="font-size: 12px">
    <img
      title="Kennwort ändern"
      src="../assets/password.svg"
      v-on:click="showChgPWS"
      style="width: 30px; height: 30px"
    /><br />Kennwort ändern
  </div>
  <div v-if="isLoggedOn" style="width: 20px; line-height: 20px">&nbsp;</div>
  <div v-if="isLoggedOn" style="font-size: 12px">
    <img
      title="Ausloggen"
      src="../assets/password.svg"
      v-on:click="doLogout"
      style="width: 30px; height: 30px"
    /><br />Ausloggen
  </div>
  <div v-if="myUser" class="usrInfo">{{ myUser.SesUserObjectName }}</div>
</template>

<script>
export default {
  name: "HomeView",
  metaInfo: {
    title: "alcondis CorServer",
  },
  computed: {
    isLoggedOn: function () {
      return this.myUser;
    },
    isAdmin() {
      // `this` points to the component instance
      return this.myUser &&
        this.myUser.AppUserSESSION_USER_ROLES &&
        this.myUser.AppUserSESSION_USER_ROLES.cksadmin
        ? "Y"
        : "N";
    },
    myData: function () {
      var dataitemsReturn = [];
      return dataitemsReturn;
    },
    myDataSize: function () {
      return this.licensplates.length;
    },
    myDataStart: function () {
      return this.startPos + 1;
    },
    myDataEnd: function () {
      return this.startPos + this.currentMaxItem > this.licensplates.length
        ? this.licensplates.length
        : this.startPos + this.currentMaxItem;
    },
    pwsChange: function () {
      //pwschange_ts
      if (!this.myUser) return false;
      var curTime = new Date().getTime();
      if (
        this.myUser &&
        this.myUser.pwschange_ts &&
        parseInt(curTime) < parseInt(this.myUser.pwschange_ts)
      ) {
        return false;
      }
      return true;
    },
    chkPW: function () {
      const regex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
      return regex.test(this.newPW1);
    },
  },
  components: {},
  data() {
    return {
      searchQuery: "",
      tokenLogon: false,
      itemsPerPage: 10,
      currentMaxItem: 10,
      startPos: 0,
      component: "",
      welcome_msg: "Welcome to alcondis Core Server",
      myTimer: "",
      mytimestamp: new Date().getTime(),
      licensplates: [],
      statusMSG: "",
      processMSG: "",
      usern: "",
      userp: "",
      myUser: "",
      curPW: "",
      newPW1: "",
      newPW2: "",
      oldPWSTS: "",
      email_send: 0,
      tokenInput: "",
      logonattempts: 0,
      cam0: 0,
      cam1: 3,
      camres: 4,
    };
  },
  mounted: function () {
    console.clear();
    console.log("Start-up app");
    var rqtoken = window.localStorage.getItem("carforce_rqtoken");
    var rqtoken_ts = window.localStorage.getItem("carforce_rqtoken_ts");
    var mydate = new Date();
    var hasToken = rqtoken ? "Y" : "N";
    var diff = rqtoken_ts
      ? Math.round((rqtoken_ts - mydate.getTime()) / 1000 / 60 / 60)
      : 0;
    console.log(hasToken, "Diff", diff);
    if (
      rqtoken != null &&
      rqtoken_ts != null &&
      mydate.getTime() < parseInt(rqtoken_ts)
    ) {
      this.tokenLogon = false;
      console.log("Check RQ-Token ");
      this.checkRQToken(rqtoken, true);
    }
  },
  methods: {
    getContext() {
      var url = window.location.href;
      if (url.includes(":3000")) return "http://localhost:8080/carforce/core";
      // AIM on server "/carforce/core"
      var aUrl = url.split("/");
      if (aUrl.length > 2) return "/" + aUrl[3] + "/core";
      return url;
    },
    solveCam() {
      if (document.getElementById("MyCamp").value == (this.cam0 + this.cam1)){
        console.log("Correct");
        this.logonattempts = 0;
      }
      else {
        alert("Not correct");
      }
    },
    closeME() {
      window.close();
    },
    parentOnline() {
      this.$root.setOnline();
    },
    showChgPWS() {
      this.oldPWSTS = this.myUser.pwschange_ts;
      this.myUser.pwschange_ts = 100;
    },
    doPWSReset() {
      this.myUser.pwschange_ts = this.oldPWSTS;
    },
    doPWS() {
      if (this.curPW && this.newPW1 && this.newPW2) {
        if (this.newPW1 == this.newPW2) {
          if (this.chkPW) {
            this.statusMSG = "";
            var comp = this;
            var myrqtoken = window.localStorage.getItem("carforce_rqtoken");
            var myAppDataURL = this.$root.core_url + "?action=chgpw";
            var d = new Date();
            var n = d.getTime();
            //J
            var jSonContent = {};
            //set values 3_ltimestamp
            jSonContent["curpw"] = this.curPW;
            jSonContent["newpw"] = this.newPW1;
            jSonContent["user"] = this.myUser.SesUserObjectName;

            var xmlhttp = new XMLHttpRequest();
            xmlhttp.addEventListener("error", function () {
              this.statusMSG =
                "Error connecting to the server => not repondig. Status-Code: " +
                this.status;
            });
            xmlhttp.onreadystatechange = function () {
              if (this.readyState == 4 && this.status == 200) {
                if (this.responseText != null) {
                  if (this.responseText) {
                    var theResult = JSON.parse(this.responseText);
                    //console.log("PWS: ", this.responseText);
                    if (
                      theResult &&
                      theResult.result &&
                      theResult.result == "OK"
                    ) {
                      comp.myUser.pwschange_ts = theResult.valid_ts;
                      comp.checkRQToken(myrqtoken, true);
                    } else {
                      alert(
                        "Fehler beim Änderung. Bitte altes Passwort überprüfen."
                      );
                    }
                  }
                }
              } else if (this.readyState == 4 && this.status != 200) {
                comp.statusMSG =
                  "Server not responding. Status: " + this.status;
              }
            };
            xmlhttp.open("POST", myAppDataURL + "&z=" + n, true);
            xmlhttp.setRequestHeader(
              "Content-Type",
              "application/json;charset=UTF-8"
            );
            //console.log(JSON.stringify(jSonContent));
            xmlhttp.setRequestHeader(
              "Authorization",
              window.localStorage.getItem("carforce_rqtoken")
            );
            xmlhttp.send(JSON.stringify(jSonContent));
          } else {
            document.getElementById("mainInfo").innerHTML =
              "Passwort zu schwach!";
            setTimeout(function () {
              document.getElementById("mainInfo").innerHTML = "";
            }, 5000);
          }
        } else {
          document.getElementById("mainInfo").innerHTML =
            "Kennwörter stimmen nicht überein";
          setTimeout(function () {
            document.getElementById("mainInfo").innerHTML = "";
          }, 5000);
        }
      }
    },
    doLogout() {
      this.statusMSG = "";
      var comp = this;
      var myAppDataURL = this.$root.core_url + "?action=do&logout=1";
      var d = new Date();
      var n = d.getTime();

      var xmlhttp = new XMLHttpRequest();
      xmlhttp.addEventListener("error", function () {
        this.statusMSG =
          "Error connecting to the server => not repondig. Status-Code: " +
          this.status;
        window.localStorage.removeItem("carforce_rqtoken");
        window.localStorage.removeItem("carforce_rqtoken_ts");
        window.localStorage.removeItem("carforce_user");
      });
      xmlhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          if (this.responseText != null) {
            if (this.responseText) {
              var theResult = JSON.parse(this.responseText);
              console.log("LOGOUT: ", this.responseText);
              window.localStorage.removeItem("carforce_rqtoken");
              window.localStorage.removeItem("carforce_rqtoken_ts");
              window.localStorage.removeItem("carforce_user");
              if (theResult && theResult.error && theResult.error == 1) {
                comp.statusMSG = theResult.msg;
              }
              comp.$root.setUser("");
              comp.myUser = "";
              comp.processMSG = "";
              comp.checkRQToken("-1", true);
              comp.$router.go();
            }
          }
        } else if (this.readyState == 4 && this.status != 200) {
          comp.statusMSG = "Server not responding. Status: " + this.status;
        }
      };
      xmlhttp.open("GET", myAppDataURL + "&z=" + n, true);
      xmlhttp.setRequestHeader(
        "Authorization",
        window.localStorage.getItem("carforce_rqtoken")
      );
      xmlhttp.send();
    },
    sendMSG() {
      this.statusMSG = "";
      var comp = this;
      var myAppDataURL = this.$root.core_url + "?action=eml";
      var d = new Date();
      var n = d.getTime();
      //J
      var jSonContent = {};
      //set values 3_ltimestamp
      jSonContent["to"] = "apptest@lanzmich.net";
      jSonContent["subject"] = "Test msg subject";
      jSonContent["msg"] = "Hier die Nachricht<br><br><br>ende der nachricht";

      var xmlhttp = new XMLHttpRequest();
      xmlhttp.addEventListener("error", function () {
        this.statusMSG =
          "Error connecting to the server => not repondig. Status-Code: " +
          this.status;
      });
      xmlhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          if (this.responseText != null) {
            if (this.responseText) {
              var theResult = JSON.parse(this.responseText);
              //console.log(theResult);
              if (
                theResult &&
                theResult.MSG &&
                theResult.MSG == "NOK" &&
                theResult.ERROR
              ) {
                document.getElementById("mainInfo").innerHTML = theResult.ERROR;
              } else {
                document.getElementById("mainInfo").innerHTML =
                  "E-Mail gesendet";
                setTimeout(function () {
                  document.getElementById("mainInfo").innerHTML = "";
                }, 3000);
              }
            }
          }
        } else if (this.readyState == 4 && this.status != 200) {
          comp.statusMSG = "Server not responding. Status: " + this.status;
        }
      };
      xmlhttp.open("POST", myAppDataURL + "&z=" + n, true);
      xmlhttp.setRequestHeader(
        "Content-Type",
        "application/json;charset=UTF-8"
      );
      //console.log(JSON.stringify(jSonContent));
      xmlhttp.setRequestHeader(
        "Authorization",
        window.localStorage.getItem("carforce_rqtoken")
      );
      xmlhttp.send(JSON.stringify(jSonContent));
    },
    checkRQToken(myrqtoken, reload) {
      this.statusMSG = "";
      var doReload = reload ? 1 : 0;
      var comp = this;
      var myAppDataURL = this.$root.core_url + "?action=2fa&reload=" + doReload;
      var d = new Date();
      var n = d.getTime();

      var xmlhttp = new XMLHttpRequest();
      xmlhttp.addEventListener("error", function () {
        this.statusMSG =
          "Error connecting to the server => not repondig. Status-Code: " +
          this.status;
      });
      xmlhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          if (this.responseText != null) {
            if (this.responseText) {
              var theResult = JSON.parse(this.responseText);
              if (theResult && theResult.error && theResult.error == 1) {
                comp.statusMSG = theResult.msg;
                comp.processMSG = "";
              } else if (theResult && theResult.rtoken) {
                var rqtoken = theResult.rtoken;
                var rqtoken_ts = theResult.rtoken_ts;
                var user = theResult.user;
                window.localStorage.setItem("carforce_rqtoken", rqtoken);
                window.localStorage.setItem("carforce_rqtoken_ts", rqtoken_ts);
                window.localStorage.setItem("carforce_user", user);
                comp.$root.setUser(user);
                comp.myUser = user;
                comp.processMSG = "";
                comp.loadMeta(rqtoken);
              }
            }
          }
        } else if (this.readyState == 4 && this.status != 200) {
          comp.statusMSG = "Server not responding. Status: " + this.status;
        }
      };
      xmlhttp.open("GET", myAppDataURL + "&z=" + n, true);
      xmlhttp.setRequestHeader("Authorization", myrqtoken);
      xmlhttp.send();
    },
    loadMeta(tp) {
      console.log("LOAD META Data");
      this.$root.loadMeta(tp);
    },
    GetCam() {
      const rndInt = Math.floor(Math.random() * 9) + 1;
      return rndInt;
    },
    do2FAlogon() {
      this.email_send = 0;
      this.tokenInput = "";
      this.statusMSG = "";
      this.cam0 = this.GetCam();
      this.cam1 = this.GetCam();
      this.camres = this.cam0 + this.cam1;
      if (document.getElementById("MyCamp"))
        document.getElementById("MyCamp").value = null || "";
      var comp = this;
      var myAppDataURL = this.getContext() + "?action=2fa";
      var d = new Date();
      var n = d.getTime();

      var xmlhttp = new XMLHttpRequest();
      xmlhttp.addEventListener("error", function () {
        this.statusMSG =
          "Error connecting to the server => not repondig. Status-Code: " +
          this.status;
      });
      xmlhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          if (this.responseText != null) {
            var theResult = JSON.parse(this.responseText);
            console.log("Benutzer anmeldung result:", this.responseText);
            if (theResult && theResult.error && theResult.error == 1) {
              comp.statusMSG = theResult.msg;
              if (theResult.logonattempts){
                comp.logonattempts = theResult.logonattempts;
              }

            } else {
              comp.processMSG =
                "Eine E-Mail wurde an " +
                comp.usern +
                " gesendet. Bitte schauen Sie auch in den Junk Ordner. Sie haben wenige Minuten Zeit um die Anmeldung zu bestätigen.";
              comp.email_send = 1;
            }
          }
        } else if (this.readyState == 4 && this.status != 200) {
          comp.statusMSG = "Server not responding. Status: " + this.status;
        }
      };
      xmlhttp.open("POST", myAppDataURL + "&z=" + n, true);
      xmlhttp.setRequestHeader(
        "Content-Type",
        "application/json;charset=UTF-8"
      );
      xmlhttp.setRequestHeader(
        "Authorization",
        window.localStorage.getItem("carforce_rqtoken")
      );
      xmlhttp.send(JSON.stringify({ user: this.usern, passwd: this.userp }));
    },
    checkToken: function (token) {
      this.tokenLogon = true;
      this.statusMSG = "";
      var comp = this;

      var myAppDataURL = this.getContext() + "?action=2fa&step=2";
      var d = new Date();
      var n = d.getTime();

      var xmlhttp = new XMLHttpRequest();
      xmlhttp.addEventListener("error", function () {
        this.statusMSG =
          "Error connecting to the server => not repondig. Status-Code: " +
          this.status;
      });
      xmlhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          if (this.responseText != null) {
            var theResult = JSON.parse(this.responseText);
            if (theResult && theResult.error && theResult.error == 1) {
              comp.statusMSG = theResult.msg;
              comp.processMSG = "";
            } else {
              var rqtoken = theResult.rtoken;
              var rqtoken_ts = theResult.rtoken_ts;
              var user = theResult.user;
              window.localStorage.setItem("carforce_rqtoken", rqtoken);
              window.localStorage.setItem("carforce_rqtoken_ts", rqtoken_ts);
              window.localStorage.setItem("carforce_user", user);
              comp.$root.setUser(user);
              comp.myUser = user;
              comp.processMSG = "";
              const queryString = window.location.search;
              const urlParams = new URLSearchParams(queryString);
              const token = urlParams.get("token");
              if (token) window.location.href = "./";
              comp.email_send = 0;
              comp.tokenInput = "";
              comp.checkRQToken(rqtoken, true);
              comp.loadMeta(rqtoken);
            }
          }
        } else if (this.readyState == 4 && this.status != 200) {
          comp.statusMSG = "Server not responding. Status: " + this.status;
        }
      };
      xmlhttp.open("GET", myAppDataURL + "&z=" + n, true);
      xmlhttp.setRequestHeader("Authorization", token);
      xmlhttp.send();
    },
    fDateTime(dt) {
      if (!dt) return "--";
      var d = new Date(+dt);
      var day = d.getDate();
      day = day < 10 ? "0" + day : day;
      var m = d.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var h = d.getHours();
      h = h < 10 ? "0" + h : h;
      var mi = d.getMinutes();
      mi = mi < 10 ? "0" + mi : mi;
      var secs = d.getSeconds();
      secs = secs < 10 ? "0" + secs : secs;
      return (
        day + "." + m + "." + d.getFullYear() + " " + h + ":" + mi + ":" + secs
      );
    },
    pageDown: function () {
      if (this.startPos - 9 > 0) {
        this.startPos = this.startPos - 10;
      } else this.startPos = 0;
    },
    pageStart: function () {
      this.startPos = 0;
    },
    pageUp: function () {
      if (this.startPos + 9 < this.myDataSize) {
        this.startPos = this.startPos + 10;
      }
    },
  },
  beforeUnmount() {
    clearInterval(this.myTimer);
  },
};
</script>
<style>
@import "../styles.css";
</style>
